"use strict";

/* global requestAnimationFrame */
var body = document.body;
var navigationToggle = document.querySelector('#navigationToggle');
var navigationPart2 = document.querySelector('.navigationPart2');
var languageToggle = document.querySelector('#languageToggle');
var selectLanguage = document.querySelector('.navigationPart3');
var allNavigationEntriesWithSub = document.querySelectorAll('.entry.withSub');
var allNavigationEntries = document.querySelectorAll('.entryNavigation');
var pathname = document.location.pathname;

var openHamburger = function openHamburger() {
  requestAnimationFrame(function () {
    body.classList.add('disable-scrolling');
    navigationPart2.classList.add('open');
    navigationToggle.classList.add('open');
    navigationToggle.classList.remove('woom-icon-hamburger-menu');
    navigationToggle.classList.add('woom-icon-hamburger-close');

    if (selectLanguage.classList.contains('open')) {
      selectLanguage.classList.remove('open');
      languageToggle.classList.remove('open');
      languageToggle.classList.remove('woom-icon-hamburger-close');
      languageToggle.classList.add('woom-icon-earth');
    }
  });
};

var closeHamburger = function closeHamburger() {
  initCurrentLinks();
  requestAnimationFrame(function () {
    body.classList.remove('disable-scrolling');
    navigationPart2.classList.remove('open');
    navigationToggle.classList.remove('open');
    navigationToggle.classList.remove('woom-icon-hamburger-close');
    navigationToggle.classList.add('woom-icon-hamburger-menu');
  });
};

var openLanguages = function openLanguages() {
  requestAnimationFrame(function () {
    body.classList.add('disable-scrolling');
    selectLanguage.classList.add('open');
    languageToggle.classList.add('open');
    languageToggle.classList.remove('woom-icon-earth');
    languageToggle.classList.add('woom-icon-hamburger-close');

    if (navigationPart2.classList.contains('open')) {
      navigationPart2.classList.remove('open');
      navigationToggle.classList.remove('open');
      navigationToggle.classList.remove('woom-icon-hamburger-close');
      navigationToggle.classList.add('woom-icon-hamburger-menu');
    }
  });
};

var closeLanguages = function closeLanguages() {
  requestAnimationFrame(function () {
    body.classList.remove('disable-scrolling');
    selectLanguage.classList.remove('open');
    languageToggle.classList.remove('open');
    languageToggle.classList.remove('woom-icon-hamburger-close');
    languageToggle.classList.add('woom-icon-earth');
  });
};

var openSubMenu = function openSubMenu(entry) {
  var subs = entry.querySelector('.subEntries');
  var arrow = entry.querySelector('.arrow-bottom');

  if (subs) {
    requestAnimationFrame(function () {
      // close all others
      allNavigationEntriesWithSub.forEach(function (navEntry) {
        if (navEntry !== entry) {
          navEntry.querySelector('.subEntries').style.height = '0px';
          navEntry.querySelector('.arrow-bottom').style.transform = 'rotate(0deg)';
        }
      });
      document.querySelectorAll('.subEntries').forEach(function (subEntriesDiv) {
        if (subEntriesDiv !== subs) {
          subEntriesDiv.style.height = '0px';
        }
      });
      subs.style.height = "".concat(subs.scrollHeight, "px");
      arrow.style.transform = 'rotate(180deg) translateY(-10px)';
    });
  }
};

var closeSubMenu = function closeSubMenu(entry) {
  var subs = entry.querySelector('.subEntries');
  var arrow = entry.querySelector('.arrow-bottom');

  if (subs) {
    requestAnimationFrame(function () {
      subs.style.height = '0px';
      arrow.style.transform = '';
    });
  }
};

var toggleSubMenu = function toggleSubMenu(entry) {
  var subs = entry.querySelector('.subEntries');

  if (subs && subs.style.height === '0px') {
    openSubMenu(entry);
  } else if (subs) {
    closeSubMenu(entry);
  }
};

var initCurrentLinks = function initCurrentLinks() {
  var lastParent;
  allNavigationEntries.forEach(function (entry) {
    var href = entry.getAttribute('href');

    if (!href) {
      lastParent = entry;
      closeSubMenu(entry);
    } else if (href === pathname || pathname.startsWith(href)) {
      entry.classList.add('current');

      if (entry.classList.contains('entryNavigationInSub')) {
        lastParent.classList.add('current');

        if (window.innerWidth < 992) {
          openSubMenu(lastParent);
        }
      }
    }
  });
};

var setupClickHandlers = function setupClickHandlers() {
  navigationToggle.onclick = function () {
    if (window.innerWidth < 992) {
      if (navigationPart2.classList.contains('open')) {
        closeHamburger();
      } else {
        openHamburger();
      }
    }
  };

  languageToggle.onclick = function () {
    if (window.innerWidth < 992) {
      if (selectLanguage.classList.contains('open')) {
        closeLanguages();
      } else {
        openLanguages();
      }
    }
  }; // submenus


  allNavigationEntriesWithSub.forEach(function (entry) {
    entry.querySelector('.withSubMain').onclick = function () {
      if (window.innerWidth < 992) {
        toggleSubMenu(entry);
      }
    };
  });
};

setupClickHandlers();
initCurrentLinks();

window.onresize = function () {
  initCurrentLinks();

  if (window.innerWidth > 991) {
    closeHamburger();
    closeLanguages();
  }
};